import React, { useEffect, useState } from 'react'

function ScreenShotSection({ screenShot,imprimable }) {

    return (<img className={`relative w-full object-contain ${imprimable === 'true' ? 'h-[400px]' : 'h-full'}`} alt='graph' src={screenShot}></img>
    )
}

export default ScreenShotSection